import axios from 'axios'

export default {
  name: 'hsdt',
  components: {},
  data () {
    return {
      firstInfo: {},
      secondInfo: {},
      firstList: [],
      secondList: [],
      hsdtIp: 'http://files.travel-yuhuatai.com:84'
    }
  },
  // 创建元素
  mounted () {
    this.getHsdt()
  },
  // 方法定义
  methods: {
    // 获取红色动态数据
    getHsdt () {
      const self = this
      const data = {
        dbCode: 'QWHSDT',
        needImage: false,
        orderField: '发布时间',
        orderType: 'desc',
        pageNumber: 1,
        pageSize: 12,
        saveLog: false
      }
      axios.post('/juanzong/retrieval/single', data).then(json => {
        if (json.data.status === '1') {
          const dataList = json.data.result.dataList
          self.firstInfo = dataList[0]
          self.secondInfo = dataList[1]
          self.firstList = dataList.slice(2, 7)
          self.secondList = dataList.slice(7)
        } else {
          self.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 点击前往更多
    goMore () {
      const url = this.hsdtIp + '/news'
      window.open(url, '_blank')
    },

    // 点击前往详情
    goDetail (info) {
      const url = `${this.hsdtIp}/news-detail?dbCode=${info.dbCode}&sysId=${info.sysid}`
      window.open(url, '_blank')
    },

    delHtmlTag (strValue) {
      if (!strValue) { return '暂无数据' }
      var temp = document.createElement('div')
      temp.innerHTML = strValue
      var output = temp.innerText || temp.textContent
      temp = null
      return output.replace(/<[^>]*>|<\/[^>]*>/gm, '')
    }
  }
}
